var angular = require('angular');
angular.module('pitch.search')
.controller('SearchFiltersCtrl', function($scope, SearchConfig, Territory, UserTerritory, UserLabel, Auth) {

    "use strict";

    $scope.context = {name: "user"};
    $scope.auditionFormat = "'mp3'";

    // if you can't see all territories, the you jolly well can't filter by them either!
    Auth.acl('territories_view')
        .then(function(isGranted) {
            if(isGranted) {
                Territory.query({}, function(resp) {
                    $scope.originatingOffices = angular.copy(resp);
                    $scope.originatingOffices.unshift({
                        name: 'Search everywhere'
                    });
                    $scope.territories = resp;
                    $scope.territories.unshift({
                        name: 'Search everywhere'
                    },{
                        id: -1,
                        name: '-- World'
                    });
                });
            } else {
                UserTerritory.get({}, function(resp) {
                    //update the territory id if undefined or a value that is not allowed without territories_view
                    if ('undefined' === typeof $scope.searchModel.territoryId ||
                        ( resp.id !== $scope.searchModel.territoryId && $scope.searchModel.territoryId != -1)) {
                        $scope.searchModel.territoryId = resp.id;
                        SearchConfig.set({'territoryId': resp.id});
                    }
                    $scope.territories =  [
                        {
                            id: resp.id,
                            name: resp.name
                        },
                        {   id: -1,
                            name: '-- World'
                        }
                    ];
                });
                Territory.query({}, function(resp) {
                    $scope.originatingOffices = angular.copy(resp);
                    $scope.originatingOffices.unshift({
                        name: 'Search everywhere'
                    });
                });
            }
        });

    UserLabel.query({}, function(resp) {
        $scope.labels = angular.copy(resp);
        $scope.labels.unshift({
            name: 'All Labels'
        });
    });

    //we have to map a filterGroupName to a query parameter.
    var map = {
        'categories': 'categoryIds',
        'versions': 'versionIds',
        'keywords': 'keywordIds',
        'entities': 'entityCodes'
    };

    $scope.getFilterKey = function(filterGroupName) {
        return map[filterGroupName];
    };

    $scope.ctrlPcts = [{
        label: 'No minimum'
    }, {
        label: '25%',
        value: 25
    }, {
        label: '50%',
        value: 50
    }, {
        label: '75%',
        value: 75
    }, {
        label: '100%',
        value: 100
    }];


    $scope.$watch("searchModel.bpmMaximum", function(newValue, oldValue) {
        if (null === newValue) {
            $scope.searchModel.bpmMaximum = undefined;
        }
    });

    $scope.$watch("searchModel.bpmMinimum", function(newValue, oldValue) {
        if (null === newValue) {
            $scope.searchModel.bpmMinimum = undefined;
        }
    });

    $scope.$watch("searchModel.yearMaximum", function(newValue, oldValue) {
        if(null === newValue) {
            $scope.searchModel.yearMaximum = undefined;
        }
    });

    $scope.$watch("searchModel.yearMinimum", function(newValue, oldValue) {
        if(null === newValue) {
            $scope.searchModel.yearMinimum = undefined;
        }
    });

    $scope.$watch("searchModel.trackId", function(newValue, oldValue) {
        if(null === newValue) {
            $scope.searchModel.trackId = undefined;
        }
    });

    $scope.$watch("searchModel.tempoSongId", function(newValue, oldValue) {
        if(null === newValue || "" === newValue) {
            $scope.searchModel.tempoSongId = undefined;
        }
    });
    
    $scope.$watch("searchModel.territoryId", function(newValue, oldValue) {
        if(undefined === newValue) {
            $scope.searchModel.controlMinimumPercentage = undefined;
        }
         
        $scope.search();
    });
    
    $scope.$watch("searchModel.originatingOfficeId", function(newValue, oldValue) {         
        $scope.search();
    });

    $scope.$watch("searchModel.labelId", function(newValue, oldValue) {
        $scope.search();
    });

});



// WEBPACK FOOTER //
// ./src/SearchClientBundle/Resources/js/angular/controllers/SearchFiltersCtrl.js